<div class="filter vehicles-tab" ngModelGroup="vehiclesGroup" #vehicles="ngModelGroup">
  <app-filter-item [title]="'Vehicle make'" [value]="vehicleMakes" [clearFilter]="clearFilter('vehicleMakes')">
    <app-multiselect-with-search
      name="makes"
      [placeholder]="'Vehicle make'"
      [options]="makeOptions"
      [(ngModel)]="vehiclesGroup.makes" />
  </app-filter-item>
  <div class="filter__column-breaker_large">
    <app-filter-item [title]="'Vehicle model'" [value]="vehicleModels" [clearFilter]="clearFilter('vehicleModels')">
      <app-multiselect-with-search
        name="models"
        [placeholder]="'Vehicle model'"
        [options]="modelOptions"
        [(ngModel)]="vehiclesGroup.models" />
    </app-filter-item>
  </div>
  <app-filter-item [title]="'Vehicle type'" [value]="vehicleTypes" [clearFilter]="clearFilter('vehicleTypes')">
    <app-multiselect-with-search
      name="types"
      [placeholder]="'Vehicle type'"
      [options]="typeOptions"
      [(ngModel)]="vehiclesGroup.types" />
  </app-filter-item>
  <div class="filter__column-breaker_large">
    <app-filter-item [title]="'Vehicle color'" [value]="vehicleColors" [clearFilter]="clearFilter('vehicleColors')">
      <app-multiselect-with-search
        name="colors"
        [placeholder]="'Vehicle color'"
        [options]="colorOptions"
        [(ngModel)]="vehiclesGroup.colors" />
    </app-filter-item>
  </div>
  <div class="vehicles-tab__release-date filter__column-breaker_large">
    <app-filter-item [title]="'Release date'" [value]="releaseYears" [clearFilter]="clearFilter('releaseDate')">
      <div class="vehicles-tab__release-date-items">
        <div class="vehicles-tab__release-date-items-from">
          <mat-form-field class="filter__select_full" appearance="outline">
            <mat-label>From</mat-label>
            <input
              matInput
              [matDatepicker]="datePickerFrom"
              name="releaseDateFrom"
              (focus)="datePickerFrom?.open()"
              [max]="vehiclesGroup.releaseDateTo || today"
              [min]="releaseMinDate"
              [(ngModel)]="vehiclesGroup.releaseDateFrom" />
            <mat-datepicker-toggle matSuffix [for]="datePickerFrom"></mat-datepicker-toggle>
            <mat-datepicker
              #datePickerFrom
              startView="multi-year"
              (yearSelected)="onYearSelected($event, datePickerFrom, 'releaseDateFrom')"></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="vehicles-tab__release-date-items-to">
          <mat-form-field class="filter__select_full" appearance="outline">
            <mat-label>To</mat-label>
            <input
              matInput
              [matDatepicker]="datePickerTo"
              name="releaseDateTo"
              (focus)="datePickerTo?.open()"
              [max]="today"
              [min]="vehiclesGroup.releaseDateFrom || releaseMinDate"
              [(ngModel)]="vehiclesGroup.releaseDateTo" />
            <mat-datepicker-toggle matSuffix [for]="datePickerTo"></mat-datepicker-toggle>
            <mat-datepicker
              #datePickerTo
              startView="multi-year"
              (yearSelected)="onYearSelected($event, datePickerTo, 'releaseDateTo')"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </app-filter-item>
    <app-filter-item title="License plate" [value]="licensePlate" [clearFilter]="clearFilter('licensePlate')">
      <div class="vehicles-tab__license-plate-items">
        <mat-form-field appearance="outline">
          <input matInput placeholder="License plate" name="licensePlate" [(ngModel)]="vehiclesGroup.licensePlate" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            #input
            matInput
            placeholder="License plate state"
            name="state"
            [required]="!!vehiclesGroup.licensePlate"
            [(ngModel)]="vehiclesGroup.state"
            [matAutocomplete]="auto"
            (input)="stateFilter.set(input.value)" />
          <mat-autocomplete
            #auto="matAutocomplete"
            [requireSelection]="true"
            [displayWith]="displayState.bind(this)"
            (optionSelected)="stateFilter.set($event.option.value)">
            @for (group of states(); track group.group) {
              @if (group.values.length) {
                <mat-optgroup [label]="group.group">
                  @for (state of group.values; track state.value) {
                    <mat-option [value]="state.value">{{ state.id }}</mat-option>
                  }
                </mat-optgroup>
              }
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </app-filter-item>
  </div>
  <div class="column-occupier-large"></div>
</div>
